<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-row justify-start items-center">
      <particle-select-basket [disabled]="true" class="m-r-20"></particle-select-basket>
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">

        <!--        <div class="button-container" fxLayout="row" fxLayoutAlign="start center">-->
        <!--          <mat-slide-toggle [(ngModel)]="autoSave" (change)="autoSaveChanged()">Auto Save</mat-slide-toggle>-->
        <!--          <div class="toolbar-separator m-l-10"></div>-->
        <!--        </div>-->

        <div class="button-container responsive-btn flex flex-row justify-start items-center">
          <button (click)="openConversation()" analyticsAction="Add-Folder"
                  analyticsCategory="file-manager-content"
                  class="orbitax-flat-button"
                  mat-button
                  particleAnalytics>Open Conversation
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container responsive-btn flex flex-row justify-start items-center">
          <button (click)="navigateToCaseFolder()" analyticsAction="Add-Folder"
                  analyticsCategory="file-manager-content"
                  class="orbitax-flat-button"
                  mat-button
                  particleAnalytics>View Documents
          </button>

          <div *ngIf="hasHallmarkTagging()" class="toolbar-separator"></div>
        </div>

        <div *ngIf="hasHallmarkTagging()"
             class="button-container responsive-btn flex flex-row justify-start items-center"
        >
          <button (click)="openHallmarkTagging()" analyticsAction="Add-Folder"
                  analyticsCategory="file-manager-content"
                  class="orbitax-flat-button"
                  mat-button
                  particleAnalytics>Hallmark Tagging
          </button>

          <div class="toolbar-separator action-btn"></div>
        </div>


        <!-- WHEN SMALL SCREEN -->
        <div class="button-container action-btn m-l-10 flex flex-row justify-start items-center">
          <button [@.disabled]="true" [matMenuTriggerFor]="menu" analyticsAction="action-button"
                  analyticsCategory="action-type-cell-viewer" class="grid-button"
                  mat-button particleAnalytics
                  style="border: 0!important;padding-left: 0">
            <span>Actions</span>
            <i class="fas fa-angle-down"></i></button>
          <div class="toolbar-separator"></div>
          <mat-menu #menu="matMenu">
            <button (click)="navigateToCaseFolder()" analyticsAction="action-dropdown"
                    analyticsCategory="action-type-cell-viewer" analyticsName="View Documents"
                    mat-menu-item particleAnalytics><span>View Documents</span></button>
          </mat-menu>
        </div>
      </div>
    </div>


    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <div class="grid-toolbar-buttons-group-without-label flex flex-row justify-start items-center">
        <button (click)="save()" [disabled]="this.editedFields.length==0" analyticsAction="Save"
                analyticsCategory="Save"
                class="start-data-survey"
                mat-button
                particleAnalytics>
          <i class="fas fa-check"></i> Save Changes ({{this.editedFields?.length}})
        </button>
      </div>
    </div>
  </div>


  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg" helpNoteId="dac6-pre-arrangement-details" particleHelpNotes>
        <!-- CONTENT TOOLBAR -->

        <div *ngIf="item" class="content  pos-relative flex flex-col full-grow-no-shrink-no-basis">
          <particle-dynamic-form-container (selectedSectionHearderKey)="selectedSectionIndexChange($event)"
                                           (fieldSelectionChange)="onSelectionFieldChanged($event)"
                                           (valueChanged)="onValueChanged($event)"
                                           [editedFields]="editedFields"
                                           [endpointName]="endpointName"
                                           [fieldConfig]="fieldConfig"
                                           [formField]="formField"
                                           [invalidateSubject]="invalidateSubject"
                                           [invalidateSubject]="invalidateSubject"
                                           [item]="item"
                                           [showLanguageOption]="showLanguageOption"
                                           [showOriginal]="showOriginal"
                                           [sourceType]="sourceType"
                                           class="particle-dynamic-form-container"
          >
          </particle-dynamic-form-container>

        </div>


      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
